<script>
import History from "./History";
import Wallet from "./Wallet";

export default {
  components: {
    History,
    Wallet
  }
};
</script>

<template>
  <div>
    <Wallet class="half"/>
    <History/>
  </div>
</template>

<style scoped>
.half {
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/WalletOfCompany/Index.vue